
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seguros/[id]",
      function () {
        return require("private-next-pages/seguros/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seguros/[id]"])
      });
    }
  